<template>
    <div class="scrolling-document">
        <ScrollingPage
            v-for="page in pages"
            :key="page.pageNumber"
            v-bind="{page, scrollTop, clientHeight, focusedPage}"
            @page-jump="onPageJump"
        >
            <div
                class="scrolling-page"
                slot-scope="{isElementVisible, isPageFocused, isElementFocused}"
            >
                <slot v-bind="{page, isElementVisible, isPageFocused, isElementFocused}"></slot>
            </div>
        </ScrollingPage>
    </div>
</template>

<script>
    import throttle from 'lodash/throttle';
    import ScrollingPage from './ScrollingPage';
    const PIXEL_RATIO = window.devicePixelRatio || 1;
    const VIEWPORT_RATIO = 0.98;

    export default {
        name: 'ScrollingDocument',
        components: {
            ScrollingPage,
        },
        props: {
            pages: {
                required: true,
            },
            currentPage: {
                type: Number,
                default: 1,
            },
            isParentVisible: {
                default: true,
            },
        },
        data() {
            return {
                focusedPage: undefined,
                scrollTop: 0,
                clientHeight: 0,
                didReachBottom: false,
            };
        },
        computed: {
            pagesLength() {
                return this.pages.length;
            },
            defaultViewport() {
                if (!this.pages.length)
                    return {width: 0, height:0};

                const [page] = this.pages;
                return page.getViewport({scale: 1.0});
            }
        },
        methods: {
            fetchPages(currentPage) {
                this.$emit('pages-fetch', currentPage);
            },
            onPageJump(scrollTop) {
                this.$emit('page-jump', scrollTop);
            },
            pageWidthScale() {
                const {defaultViewport, $el} = this;
                if (!defaultViewport.width)
                    return 0;

                return ($el.clientWidth * PIXEL_RATIO) * VIEWPORT_RATIO / defaultViewport.width;
            },
            fitWidth() {
                const scale = this.pageWidthScale();
                console.log('fit width scale', scale);
                this.$emit('scale-change', scale);
            },
            updateScrollBounds() {
                const {scrollTop, clientHeight} = this.$el;
                this.scrollTop = scrollTop;
                this.clientHeight = clientHeight;
                this.didReachBottom = this.isBottomVisible();
            },
            isBottomVisible() {
                const {scrollTop, clientHeight, scrollHeight} = this.$el;
                return scrollTop + clientHeight >= scrollHeight;
            },
            onResize() {
                this.fitWidth();
                this.updateScrollBounds();
            }
        },
        watch: {
            isParentVisible: 'updateScrollBounds',
            pageCount: 'fitWidth',
            fetchedPageCount(count, oldCount) {
                if (oldCount === 0)
                    this.fitWidth();
            },
            pagesLength(count, oldCount) {
                if (oldCount === 0)
                    this.$emit('pages-reset');

                // Set focusedPage after new pages are mounted
                this.$nextTick(() => {
                    this.focusedPage = this.currentPage;
                });
            },
            currentPage(currentPage) {
                if (currentPage > this.pages.length) {
                    this.fetchPages(currentPage);
                } else {
                    this.focusedPage = currentPage;
                }
            },
            didReachBottom(didReachBottom) {
                if (didReachBottom)
                    this.fetchPages();
            }
        },
        mounted() {
            this.updateScrollBounds();
            this.$el.addEventListener('scroll', throttle(this.updateScrollBounds, 300), true);

            const throttledOnResize = throttle(this.onResize, 300);
            window.addEventListener('resize', throttledOnResize, true);
            this.throttledOnResize = throttledOnResize;
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.throttledOnResize, true);
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/pdfViewer/ScrollingDocument.vue